
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "Dialog",
})
export default class Dialog extends Vue {
  @Prop({ default: true }) showModal!: boolean;

  @Prop({ default: "" }) title!: string;

  @Prop({ default: "" }) description!: string;

  @Prop({ default: "" }) textDescriptionClass!: string;

  @Prop({ default: "" }) titleDescriptionClass!: string;

  @Prop({ default: "Entendi" }) buttonText?: string;

  @Prop({ default: true }) showButtonClose?: boolean;

  @Prop({ default: true }) showHeader?: boolean;

  @Prop({ default: true }) showFooter?: boolean;

  @Prop({ default: "confirmation" }) isDialogType?: string;

  @Prop({ default: false }) readonly isQrCodeAlert!: boolean;

  @Prop({ default: false }) readonly isPaynentAlert?: boolean;

  @Prop({ default: "sm" }) sizeModal?: "sm" | "lg";

  @Prop({ default: "" }) token?: string;

  @Prop({ default: false }) readonly detectMob?: boolean;

  @Prop({ default: "" }) readonly closeTitle?: string;

  @Prop({ default: "" }) readonly okTitle?: string;

  uriFrame = process.env.VUE_APP_API_M4U_FRAME;
}
